import React from 'react'
import { Search } from 'lucide-react'
import { Input } from '@/components/ui/input'

interface SearchQueryProps {
  searchQuery: string
  onSearchChange: (_query: string) => void
  placeholder?: string
}

export const SearchQuery: React.FC<SearchQueryProps> = ({
  searchQuery,
  onSearchChange,
  placeholder = 'Buscar...',
}) => {
  return (
    <div className="relative w-full">
      <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 transform text-muted-foreground" />
      <Input
        className="bg-white pl-10"
        onChange={(e) => onSearchChange(e.target.value)}
        placeholder={placeholder}
        value={searchQuery}
      />
    </div>
  )
}
